/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GroupSettings } from '../models/GroupSettings';
import { GroupTypeEnum } from '../models/GroupTypeEnum';
import { SimpleGroupHorse } from '../models/SimpleGroupHorse';
import { SimpleGroupUser } from '../models/SimpleGroupUser';
import { StallionGroup } from '../models/StallionGroup';
import { URI } from '../models/URI';
import { HttpFile } from '../http/http';

export class Group {
    'id': number;
    'uid': string;
    'users': Array<SimpleGroupUser>;
    'horses': Array<SimpleGroupHorse>;
    'stallionGroup'?: StallionGroup;
    'dtCreated': Date;
    'name'?: string;
    'description'?: string;
    'groupType': GroupTypeEnum;
    'thumbnail'?: URI;
    'settings'?: GroupSettings;
    'locationString'?: string;
    'website'?: string;
    'country'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "uid",
            "baseName": "uid",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<SimpleGroupUser>",
            "format": ""
        },
        {
            "name": "horses",
            "baseName": "horses",
            "type": "Array<SimpleGroupHorse>",
            "format": ""
        },
        {
            "name": "stallionGroup",
            "baseName": "stallionGroup",
            "type": "StallionGroup",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "groupType",
            "baseName": "groupType",
            "type": "GroupTypeEnum",
            "format": ""
        },
        {
            "name": "thumbnail",
            "baseName": "thumbnail",
            "type": "URI",
            "format": "uri"
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "GroupSettings",
            "format": ""
        },
        {
            "name": "locationString",
            "baseName": "locationString",
            "type": "string",
            "format": ""
        },
        {
            "name": "website",
            "baseName": "website",
            "type": "string",
            "format": ""
        },
        {
            "name": "country",
            "baseName": "country",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Group.attributeTypeMap;
    }

    public constructor() {
    }
}



